import { Plus } from "lucide-react";
import { useLingui } from "@lingui/react/macro";
import { AppDialog } from "@/components/common/AppDialog";
import { Button } from "@/components/ui/button";
import { sessionTone } from "@/lib/multi-view";
import type { CookingSession } from "@/types/cooking-session";
import { SessionChip } from "./SessionChip";

interface AddRecipesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Recipes on Prep that are not in the view yet. */
  candidates: CookingSession[];
  onAdd: (session: CookingSession) => void;
}

/** "+ Add recipes": the rest of what is on Prep, one tap each. */
export function AddRecipesDialog({ open, onOpenChange, candidates, onAdd }: AddRecipesDialogProps) {
  const { t } = useLingui();
  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t`Add recipes`}
      description={t`Recipes on Prep that are not in this view yet.`}
      size="md"
    >
      {candidates.length === 0 ? (
        <p className="text-sm text-(--color-text-secondary)">{t`Every recipe on Prep is already in this view.`}</p>
      ) : (
        <ul className="flex max-h-96 flex-col gap-2 overflow-y-auto">
          {candidates.map((session) => (
            <li key={session.id} className="flex items-center justify-between gap-3">
              <SessionChip name={session.recipeName} tone={sessionTone(session, session.elapsedSeconds)} />
              <Button type="button" size="sm" variant="brand-outline" onClick={() => onAdd(session)} className="gap-1.5">
                <Plus />
                {t`Add`}
              </Button>
            </li>
          ))}
        </ul>
      )}
    </AppDialog>
  );
}
